import React, { useMemo } from 'react';
import './CustomYAxis.css';
import { formatCompactCurrency } from '../utils/formatters';


const CustomYAxis = ({ ticks = [], chartHeight }) => {

    if (!ticks || ticks.length === 0) return null;

    // Reverse ticks so highest value is at top (Chart.js returns them in ascending order)
    const reversedTicks = [...ticks].reverse();
    
    // Calculate tick positions based on chart height
    // Chart.js distributes ticks evenly from top to bottom within the chart area
    // Match the chart's internal padding for perfect alignment
    const chartPaddingTop = 5;  // Adjusted to match chart rendering
    const chartPaddingBottom = 10; // Adjusted to match chart rendering
    const effectiveHeight = chartHeight - chartPaddingTop - chartPaddingBottom;
    
    const tickPositions = reversedTicks.map((tick, index) => {
        // Position from top within the effective chart area
        const relativePosition = index / (reversedTicks.length - 1);
        const pixelPosition = chartPaddingTop + (relativePosition * effectiveHeight);
        
        return {
            value: tick,
            position: pixelPosition
        };
    });

    return (
        <div className="custom-y-axis" style={{ height: `${chartHeight}px` }}>
            {tickPositions.map((tick, index) => (
                <div 
                    key={index}
                    className="y-axis-tick"
                    style={{ top: `${tick.position}px` }}
                >
                    <span className="y-axis-label">
                        {formatCompactCurrency(tick.value)}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default CustomYAxis;

